"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeInsightWidgetInsightHandler = void 0;
var tslib_1 = require("tslib");
var redux_batched_actions_1 = require("redux-batched-actions");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var widgetValidations_1 = require("./validation/widgetValidations");
var layout_1 = require("../../store/layout");
var insight_1 = require("../../events/insight");
var sdk_model_1 = require("@gooddata/sdk-model");
var general_1 = require("../../events/general");
var insights_1 = require("../../store/insights");
var ui_1 = require("../../store/ui");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
var sizing_1 = require("../../../_staging/layout/sizing");
var loadInsight_1 = require("./common/loadInsight");
function changeInsightWidgetInsightHandler(ctx, cmd) {
    var _a, ref, insightRef, visualizationProperties, correlationId, widgets, insightWidget, originalInsight, originalInsightTitle, insight, _b, hasCustomName, isTitleDifferent, shouldChangeTitle, newSize;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = cmd.payload, ref = _a.ref, insightRef = _a.insightRef, visualizationProperties = _a.visualizationProperties, correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _c.sent();
                insightWidget = widgetValidations_1.validateExistingInsightWidget(widgets, cmd, ctx);
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightByRef(insightWidget.insight))];
            case 2:
                originalInsight = _c.sent();
                ts_invariant_1.default(originalInsight, "inconsistent store, original insight not already in store");
                originalInsightTitle = sdk_model_1.insightTitle(originalInsight);
                _c.label = 3;
            case 3:
                _c.trys.push([3, 5, , 6]);
                return [4 /*yield*/, effects_1.call(loadInsight_1.loadInsight, ctx, insightRef)];
            case 4:
                insight = _c.sent();
                return [3 /*break*/, 6];
            case 5:
                _b = _c.sent();
                throw general_1.invalidArgumentsProvided(ctx, cmd, "The insight with ref: " + sdk_model_1.serializeObjRef(insightRef) + " was not found.");
            case 6:
                hasCustomName = sdk_model_1.widgetTitle(insightWidget) !== originalInsightTitle;
                isTitleDifferent = sdk_model_1.insightTitle(insight) !== originalInsightTitle;
                shouldChangeTitle = !hasCustomName && isTitleDifferent;
                newSize = sizing_1.getSizeInfo({ enableKDWidgetCustomHeight: true }, "insight", insight);
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([
                        // upsert the internal insight list
                        insights_1.insightsActions.upsertInsight(insight),
                        // refresh the visual insight list
                        ui_1.uiActions.requestInsightListUpdate(),
                        /**
                         * Change the widget:
                         * - insight
                         * - properties if set
                         * - title if appropriate
                         */
                        layout_1.layoutActions.replaceInsightWidgetInsight({
                            ref: ref,
                            insightRef: insightRef,
                            properties: visualizationProperties,
                            header: shouldChangeTitle
                                ? {
                                    title: sdk_model_1.insightTitle(insight),
                                }
                                : undefined,
                            newSize: newSize,
                            undo: {
                                cmd: cmd,
                            },
                        }),
                    ]))];
            case 7:
                _c.sent();
                return [2 /*return*/, insight_1.insightWidgetInsightChanged(ctx, ref, insight, correlationId)];
        }
    });
}
exports.changeInsightWidgetInsightHandler = changeInsightWidgetInsightHandler;
//# sourceMappingURL=changeInsightWidgetInsightHandler.js.map